<script>
    import { page } from '$app/stores';
    import { getContext } from 'svelte';

    export let maxWidth;
    export let padding;
    export let style = '';

    export let title = '';
    export let description = '';
    export let alignment = '';
    export let titleType = '';
    export let headerVisibile = true;

    export let device = '';
    export let userVisibility = '';
    export let userSegmentID = '';
    export let userTag = '';

    // User Data
    const isUser = $page.data.user.persistent;
    const userTags = $page.data.user.tags;
    const userSegments = $page.data.user.segments;

    // Set section max width
    let maxWidthClass = '';
    switch (maxWidth) {
        case 'Default':
            maxWidthClass = '';
            break;
        case 'Full':
            maxWidthClass = 'max-w-full';
            break;
        case 'Medium':
            maxWidthClass = 'max-w-7xl';
            break;
        case 'Tight':
            maxWidthClass = 'max-w-4xl';
            break;
        default:
            maxWidthClass = '';
            break;
    }

    // Set section padding
    let paddingClass = '';
    switch (padding) {
        case 'Top & Bottom':
            paddingClass = 'px-2 py-8 lg:px-4';
            break;
        case 'Top':
            paddingClass = 'px-2 pt-8 lg:px-4';
            break;
        case 'Bottom':
            paddingClass = 'px-2 pb-8 lg:px-4';
            break;
        case 'None':
            paddingClass = 'px-2 py-0 lg:px-4';
            break;
        default:
            paddingClass = 'px-2 py-8 lg:px-4';
            break;
    }

    // Set section device visibility
    let deviceClass = '';
    switch (device) {
        case 'Desktop & Mobile':
            deviceClass = 'block';
            break;
        case 'Desktop':
            deviceClass = 'hidden lg:block';
            break;
        case 'Mobile':
            deviceClass = 'lg:hidden';
            break;
        case 'PWA':
            deviceClass = 'hidden pwa:block';
            break;
        case 'PWA Hidden':
            deviceClass = 'pwa:hidden';
            break;
        case 'Hidden':
            deviceClass = 'hidden';
            break;
        default:
            deviceClass = 'block';
            break;
    }

    // Set section Style
    let sectionFeaturedClass = '';
    let sectionFramed = '';
    switch (style) {
        case 'None':
            sectionFeaturedClass = '';
            break;
        case 'Framed':
            sectionFramed = 'rounded-xl border border-base-900/5 bg-base-900 p-4 shadow-sm lg:p-8';
            break;
        case 'Featured':
            sectionFeaturedClass = 'featured-gradient pb-4 lg:pb-8';
            break;
        case 'Gradient Framed':
            sectionFramed = 'featured-gradient rounded-xl p-4 shadow-sm lg:p-8';
            break;
        case 'Gradient Full':
            sectionFeaturedClass = 'featured-gradient';
            break;
        case 'Base Full':
            sectionFeaturedClass = 'bg-base-900';
            break;
        default:
            sectionFeaturedClass = '';
            break;
    }

    // Set section header alignment
    let sectionAlignment = '';
    switch (alignment) {
        case 'Left':
            sectionAlignment = 'text-left';
            break;
        case 'Center':
            sectionAlignment = 'text-center';
            break;
        case 'Right':
            sectionAlignment = 'text-right';
            break;
        default:
            sectionAlignment = '';
            break;
    }

    // Set User Visibility
    let isVisible = false;
    switch (userVisibility) {
        case '':
        case 'All Users':
            isVisible = true;
            break;
        case 'Logged In':
            if (isUser) isVisible = true;
            break;
        case 'Logged Out':
            if (!isUser) isVisible = true;
            break;
        case 'Has Tag':
            if (userTags.includes(userTag)) isVisible = true;
            break;
        case 'Does Not Have Tag':
            if (!userTags.includes(userTag)) isVisible = true;
            break;
        case 'In Segment':
            if (userSegments.includes(userSegmentID)) isVisible = true;
            break;
        case 'Not In Segment':
            if (!userSegments.includes(userSegmentID)) isVisible = true;
            break;
        default:
            isVisible = false;
            break;
    }

    // Set/Get section position (only if section isVisible )
    const ctx = getContext('ctx');
    const position = isVisible ? ctx.sectionPosition.increaseSectionPosition() : null;
</script>

{#if isVisible}
    <div class="{deviceClass} {sectionFeaturedClass}" data-sectionposition={position}>
        <div class="container {maxWidthClass} {paddingClass}">
            {#if headerVisibile}
                <div class="mb-2 px-2 {sectionAlignment} {alignment === 'Center' ? 'mx-auto max-w-xs lg:max-w-xl' : ''}">
                    {#if title}
                        <svelte:element this={titleType} class="text-lg font-semibold lg:text-xl">{title}</svelte:element>
                    {/if}
                    {#if description}
                        <p class="text-xs lg:text-base">{description}</p>
                    {/if}
                </div>
            {/if}
            {#if sectionFramed}
                <div class={sectionFramed}>
                    <slot />
                </div>
            {:else}
                <slot />
            {/if}
        </div>

        {#if style === 'Featured'}
            <div class="-mb-5 h-8 w-full rounded-t-[2rem] bg-color-background lg:-mb-8"></div>
        {/if}
    </div>
{/if}
